<div style="height: 344px;width:100%;z-index:0" id="socmap">
       
</div>
<p-growl *ngIf="createReqerrormsg.length!==0" life='3000' [(value)]="createReqerrormsg"></p-growl>
<app-form *ngIf="servicerequestDialog2" [greetMessage]="sitemapdata" [org]='org' [reqType]="_dataProvider.getReportTroubleReqId()" (closeForm)="closeForm($event)"></app-form>